import { render } from "./legacySoldOrder.vue?vue&type=template&id=6ec7d617&scoped=true"
import script from "./legacySoldOrder.vue?vue&type=script&lang=js"
export * from "./legacySoldOrder.vue?vue&type=script&lang=js"

import "./legacySoldOrder.vue?vue&type=style&index=0&id=6ec7d617&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec7d617"]])

export default __exports__